import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
const meta = {
  "/": {
    es: {
      title: "GRANSACA.COM | Granzonera y Agregados San Antonio, C.A. - Agregados para la construcción en Venezuela",
      description: "Producción y comercialización de agregados para la construcción en Venezuela: arena, polvillo, piedra 3/4, piedra 7/8, granzón, base y material de relleno. Planta trituradora moderna y suministro confiable."
    },
    en: {
      title: "GRANSACA.COM | Granzonera y Agregados San Antonio, C.A. - Construction aggregates in Venezuela",
      description: "Production and supply of construction aggregates in Venezuela: sand, stone dust, 3/4 stone, 7/8 stone, granzón, base and fill material. Modern crushing plant and reliable supply."
    }
  },
  "/politica-de-privacidad": {
    es: {
      title: "Política de Privacidad | GRANSACA.COM",
      description: "Política de Privacidad de Granzonera y Agregados San Antonio, C.A. (GRANSACA): datos que procesa el sistema de registro administrativo, finalidad, conservación y derechos del usuario."
    },
    en: {
      title: "Privacy Policy | GRANSACA.COM",
      description: "Privacy Policy of Granzonera y Agregados San Antonio, C.A. (GRANSACA): data processed by the administrative record system, purpose, retention and user rights."
    }
  },
  "/terminos-de-servicio": {
    es: {
      title: "Términos de Servicio | GRANSACA.COM",
      description: "Términos de Servicio del sistema interno de registro administrativo de Granzonera y Agregados San Antonio, C.A. (GRANSACA): uso autorizado y responsabilidades."
    },
    en: {
      title: "Terms of Service | GRANSACA.COM",
      description: "Terms of Service for the internal administrative record system of Granzonera y Agregados San Antonio, C.A. (GRANSACA): authorized use and responsibilities."
    }
  },
  "/eliminar-datos": {
    es: {
      title: "Eliminar Datos | GRANSACA.COM",
      description: "Solicite la eliminación de sus datos personales en GRANSACA por correo electrónico o enviando “ELIMINAR MIS DATOS” al WhatsApp financiero."
    },
    en: {
      title: "Delete Data | GRANSACA.COM",
      description: "Request the deletion of your personal data at GRANSACA by email or by sending “ELIMINAR MIS DATOS” to the financial WhatsApp."
    }
  }
} as const;
const keywords = "Granzonera, Agregados para construcción, Materiales de construcción, Arena, Polvillo, Piedra 3/4, Piedra 7/8, Granzón, Base, Planta trituradora, Trituración de piedra, Agregados pétreos, Cantera, Venezuela";
function setMeta(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Keeps document title + meta in sync with the active route and language (SEO).
export function Seo() {
  const {
    lang
  } = useLanguage();
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    const route = (meta as Record<string, typeof meta["/"]>)[pathname] ?? meta["/"];
    const m = route[lang];
    document.title = m.title;
    document.documentElement.lang = lang;
    setMeta("description", m.description);
    setMeta("keywords", keywords);
    setMeta("robots", "index, follow");
  }, [lang, pathname]);
  return null;
}